import React from 'react';
import { Menu } from 'lucide-react';

const Navbar = ({ onMenuClick, showMenuButton }) => {
  return (
    <header className="bg-white shadow-sm p-4 flex items-center justify-between border-b border-gray-200 sticky top-0 z-10">
      <div className="flex items-center flex-1">
        {showMenuButton && (
          <button
            onClick={onMenuClick}
            className="p-2 mr-2 rounded-lg hover:bg-gray-100 text-gray-600 transition-colors"
          >
            <Menu size={20} />
          </button>
        )}
      </div>
      <div className="flex items-center space-x-4">
        {/* User Avatar removed as per request (keeping Sidebar one) */}
      </div>
    </header>
  );
};

export default Navbar;